import React from 'react';
import styled from 'styled-components';
import Transaction from './components/Transaction';
import { TranslationHelpers } from '../../../../i18n/translationHelpers';
import { IHistoryEntry } from '../redux/rewardsTransactionsHistory.service';
import { SPACINGS, COLORS, MQS } from '../../../../app/common/constants/styles';

const Grid = styled.div``;

export const Row = styled.div`
    display: flex;
    align-items: center;
`;

const Header = styled.div`
    color: ${COLORS.grey};
    font-weight: 400;
    text-align: center;
    padding: ${SPACINGS.base}px 0;
    font-size: 12px;
    width: 30%;
    word-wrap: break-word;
    padding: 1px;

    @media (min-width: ${MQS.mq2Min}) {
        width: 13%;
        margin-right: 1%;
    }

    @media (min-width: ${MQS.mq3Min}) {
        font-size: 14px;
    }
`;

const CollapsingHeader = styled.div`
    color: ${COLORS.grey};
    padding: ${SPACINGS.base}px 0;
    font-weight: 400;
    text-align: center;
    display: none;
    font-size: 12px;
    width: 30%;
    word-wrap: break-word;
    padding: 1px;

    @media (min-width: ${MQS.mq2Min}) {
        display: block;
        width: 13%;
        margin-right: 1%;
        word-break: break-word;
    }

    @media (min-width: ${MQS.mq3Min}) {
        font-size: 14px;
    }
`;

const MobileTableMoreInfoHeader = styled.div`
    color: ${COLORS.grey};
    padding: ${SPACINGS.base}px 0;
    font-weight: 400;
    text-align: center;
    display: block;
    width: 10%;
    font-size: 12px;

    @media (min-width: ${MQS.mq2Min}) {
        display: none;
    }
`;

export const TRANS_TABLE_DATA_QA_ID = 'rewards-transactions-table';

class TransactionTable extends React.Component<{
    transactions: IHistoryEntry[];
    pointsSelected: boolean;
    selectedLocale: string;
}> {
    render() {
        const { transactions, pointsSelected, selectedLocale } = this.props;
        if (transactions.length > 0) {
            const groupTransactions = transactions.map((transaction, i) => (
                <Transaction
                    key={'transaction-table-' + transaction.transactionId + '-' + i}
                    transaction={transaction}
                    pointsSelected={pointsSelected}
                    selectedLocale={selectedLocale}
                />
            ));
            const transactionsTableHeader = pointsSelected ? (
                <>
                    <Header data-qa-id={TRANS_TABLE_DATA_QA_ID + '-header-points'}>
                        {TranslationHelpers.getFormattedMessage('points.points')}
                    </Header>
                    <CollapsingHeader>
                        {TranslationHelpers.getFormattedMessage('points.earned.spent')}
                    </CollapsingHeader>
                    <CollapsingHeader>
                        {TranslationHelpers.getFormattedMessage('points.type')}
                    </CollapsingHeader>
                    <Header>
                        {TranslationHelpers.getFormattedMessage('points.transaction.date')}
                    </Header>
                    <CollapsingHeader>
                        {TranslationHelpers.getFormattedMessage('points.order.number')}
                    </CollapsingHeader>
                    <Header>
                        {TranslationHelpers.getFormattedMessage('points.order.details')}
                    </Header>
                    <CollapsingHeader>
                        {TranslationHelpers.getFormattedMessage('points.service')}
                    </CollapsingHeader>
                </>
            ) : (
                <>
                    <Header data-qa-id={TRANS_TABLE_DATA_QA_ID + '-header-cashback'}>
                        {TranslationHelpers.getFormattedMessage('points.cashback.cash')}
                    </Header>
                    <CollapsingHeader>
                        {TranslationHelpers.getFormattedMessage('points.earned.spent')}
                    </CollapsingHeader>
                    <CollapsingHeader>
                        {TranslationHelpers.getFormattedMessage('points.cashback.cashback_type')}
                    </CollapsingHeader>
                    <Header>
                        {TranslationHelpers.getFormattedMessage('points.transaction.date')}
                    </Header>
                    <CollapsingHeader>
                        {TranslationHelpers.getFormattedMessage('points.order.number')}
                    </CollapsingHeader>
                    <Header>
                        {TranslationHelpers.getFormattedMessage('points.order.details')}
                    </Header>
                    <CollapsingHeader>
                        {TranslationHelpers.getFormattedMessage('points.service')}
                    </CollapsingHeader>
                </>
            );

            return (
                <Grid data-qa-id={TRANS_TABLE_DATA_QA_ID}>
                    <Row data-qa-id={TRANS_TABLE_DATA_QA_ID + '-header'}>
                        {transactionsTableHeader}
                        <MobileTableMoreInfoHeader></MobileTableMoreInfoHeader>
                    </Row>
                    {groupTransactions}
                </Grid>
            );
        } else {
            return null;
        }
    }
}

export default TransactionTable;
